import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "../store";

interface NavigationState {
  lastUrl: string | null;
}

const initialState: NavigationState = {
  lastUrl: null,
};

const navigationSlice = createSlice({
  name: "navigation",
  initialState,
  reducers: {
    setLastUrl: (state, action) => {
      state.lastUrl  = action.payload;
    },
  },
});

export const { setLastUrl } = navigationSlice.actions;

export const selectLastUrl = (state: RootState) =>
  state.navigation.lastUrl;

export default navigationSlice.reducer;
